import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class FeatureCriteria extends BasicCriteria {
isTab: boolean;
isVision: boolean;
isVisionStep: boolean;
isVisionStepPerimeter: boolean;
perimeter: string;
perimeters: string[];
visionCode: string;
}

